// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__33F8l","right":"styles_right__3Hpgf"};